/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_File_Tree_Header_DescriptionInputs */

const es_components_file_tree_header_description = /** @type {(inputs: Components_File_Tree_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administra archivos para que Nexata pueda tener conocimiento sobre su contenido.`)
};

const en_components_file_tree_header_description = /** @type {(inputs: Components_File_Tree_Header_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage files so Nexata can understand their content.`)
};

/**
* | output |
* | --- |
* | "Manage files so Nexata can understand their content." |
*
* @param {Components_File_Tree_Header_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_file_tree_header_description = /** @type {((inputs?: Components_File_Tree_Header_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_File_Tree_Header_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_file_tree_header_description(inputs)
	return en_components_file_tree_header_description(inputs)
});
export { components_file_tree_header_description as "components.file_tree.header_description" }